<template>
  <div class="event_managing">
    <div style="padding: 0px 20px">
      <div class="search">
        <div class="search_box">
          <div v-for="item in search" :class='["search_options_box"]'>
            <span style="width: 100px;">{{item.title}}</span>
            <el-select class="select" v-model="selectValue" placeholder="请选择项目" @change="getSelectProject()">
              <el-option v-for="item2 in item.options" :label="item2.label" :value="item2.value" :key="item2.value"></el-option>
            </el-select>
          </div>
          <div class="add_btn_box">
            <button :class='["add_btn","publish","icon_btn","clearborder"]' @click="issue()"><span class="el-icon-s-promotion"></span>发布</button>
            <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="Delete =!Delete"><span class="el-icon-delete"></span>删除</button>
            <button :class='["add_btn","add","icon_btn","clearborder"]' @click="add()"><span class="el-icon-circle-plus-outline"></span>添加</button>
          </div>
        </div>
      </div>

      <!--        表格-->
      <div class="table_content">
        <table>
          <thead>
          <tr>
            <th style="width: 50px"><input type="checkbox" name="all" @click='ProgramCheckedAll()'></th>
            <th style="padding-left: 30px">序号</th>
            <th>节目名称</th>
            <th>
              <select>
                <option value="全部">&nbsp;&nbsp;&nbsp;全部</option>
                <option value="已发布">已发布</option>
                <option value="未发布">未发布</option>
              </select>
            </th>
            <th>作者</th>
            <th>创建时间</th>
            <th>上次播放时间</th>
            <th>已发布到</th>
            <th>操作</th>
          </tr>
          </thead>
          <tbody>
          <tr  v-for="(item,index) in tabledata">
            <td><input type="checkbox" name="program" :value="item.id" v-model="program_id" @click='ProgramCheckedOne(item.id.toString())'></td>
            <td style="padding-left: 30px">{{index+1}}</td>
            <td>{{item.name}}</td>
            <td v-if="item.is_publish==='1'">已发布</td>
            <td v-else-if="item.is_publish==='0'">未发布</td>
            <td v-else>全部</td>
            <td>{{item.author}}</td>
            <td>{{item.create_datetime}}</td>
            <td>{{item.last_play}}</td>
            <td v-if="item.publish_address==='未发布'">未发布</td>
            <td v-else v-for="item_2 in item.publish_address">
              <span>{{item_2}}</span>
            </td>
            <td v-if="item.publish_address=[]">暂无数据</td>
            <td class="table_btn_box">
              <button class="table_btn" @click="fix(item.id)">编辑</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="table_paging">
        <p>当前记录<span>1</span>到<span>5</span>条，共<span>45</span>条记录
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_start.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_prep.png) no-repeat center center'}]"></button>
          第<span>1</span>/<span>5</span>页
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_next.png) no-repeat center center'}]"></button>
          <button
            v-bind:style="[{background:'url(/static/img/icon/table_end.png) no-repeat center center'}]"></button>
        </p>
      </div>
    </div>

    <transition name="fade">
      <div class="mark" v-if="show">
        <div class="mark_close" @click="show=!show"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'1200px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box">
            <h1>
              关联LED屏
              <div>
              <label v-for="(item,index) in issue_search">
                {{item.title}}:
                <select class="select">
                  <option v-for="item2 in item.select" v-bind:value='item2.option'>{{item2.option}}</option>
                </select>
              </label>
              <label>LED编码:<input type="text" placeholder="请输入LED编码"></label>
                <button :class='["add_btn","add","icon_btn","clearborder"]' style="margin-left: 30px">搜索</button>
              <button :class='["add_btn","publish","icon_btn","clearborder"]' @click="issue_sbt()">发布</button>
              </div>
            </h1>
            <div>
              <table>
                <thead>
                <tr>
                  <td style="width: 50px"><input type="checkbox" @click='LEDCheckedAll()'></td>
                  <th>LED名称</th>
                  <th>LED屏编码</th>
                  <th>灯杆编号</th>
                  <th>所属项目</th>
                  <th>所属分组</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in issue_search_table">
                  <td style="width: 50px"><input type="checkbox" name="led" @click='LEDCheckedOne(item.id.toString())' :value="item.id" v-model="led_id"></td>
                  <td>{{item.site}}</td>
                  <td>{{item.device_num}}</td>
                  <td>{{item.id}}</td>
                  <td>{{item.project_name}}</td>
                  <td>{{item.groups_name}}</td>
                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </transition>

    <transition name="fade">
      <div class="mark" v-if="Delete">
        <div class="mark_close" @click="Delete=!Delete"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="h_light_right" :style="{top:'95px'}"></div>
          <div class="information_content issue_search_box model">
            <h1>
              删除
            </h1>
            <div style="padding: 0 60px;box-sizing: border-box;height: 68px">
              <h1>是否要删除已选择的节目</h1>
            </div>
            <div class="sbt_box">
              <button :class='["add_btn","delete","icon_btn","clearborder"]' @click="Delete=!Delete">取消</button>
              <button :class='["add_btn","add","icon_btn","clearborder"]' @click="Delete_sbt()">确定</button>
            </div>
          </div>
        </div>
      </div>
    </transition>


    <transition name="fade" v-on:leave="leave">
      <div class="mark" v-if="msg_show">
        <div class="mark_close" @click="msg_show=!msg_show"></div>
        <div :class='["information_box","light_border","weather_box"]'
             :style="[{width:'500px'},{'margin-top':'0px'}]">
          <div class="border_top_left"></div>
          <div class="border_top_right"></div>
          <div class="border_bottom_left"></div>
          <div class="border_bottom_right"></div>
          <div class="information_content issue_search_box model">
            <div id="msg">{{message}}</div>
          </div>
        </div>
      </div>
    </transition>


  </div>
</template>

<script>
  export default {
    name: "equipment_management",
    data() {
      return {
        show:false,
        search: [
          {
            title: '选择项目',
            options: [],
          },
        ],
        selectValue:'17e3b71e-b460-498e-b0ef-657d20bd6549',
        projectList:[],
        issue_search:[
          {
            title: '选择群组',
            select: [
              {option: "第一群组"},
            ]
          },{
            title: '选择小组',
            select: [
              {option: "组一"},
            ]
          },
        ],
        issue_search_table:[],


        //复选框选中值缓存
        program_id:[],
        led_id:[],

        ProgramIsCheckedAll:false,
        LEDIsCheckedAll:false,
        refresh: false,
        msg_show: false,
        message: '',

        Delete:false,


        tabledata: []
      }
    },
    methods:{
      InitLeftMenu: function () {
        this.$emit('getMessage', '4', '2');
      },

      getSelectProject:function(){
        fetch("/api/v1/led/program/list", {
          method: 'post',
          body: JSON.stringify({
            "project_id": this.selectValue,
            "page_start":"0",
            "page_size":"9",
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            this.tabledata = data.data;
          })
          .catch((error) => {
            console.log(error);
          });
      },


      //获取项目列表
      getProjectList:function(){
        fetch("/api/v1/project/list", {
          method: 'post',
          body: JSON.stringify({

          })
        })
          .then(result => {
            return result.json();//解析流
          })
          //.then(data => console.log(data))
          .then(data => {
            if (data.code == "200") {
              this.message = "项目数据获取成功";
              this.projectList = data.data;
              let options = this.search[0].options;
              for (let i=0;i<this.projectList.length;i++){
                let projectObj = {};
                projectObj.label = this.projectList[i].name;
                projectObj.value = this.projectList[i].id;
                options.push(projectObj);
              };
            } else {
              this.message = "数据更新异常，请重试";
            }
          })
          .catch((error) => {
            this.message = "网络异常，请重试";
            this.msg_show = !this.msg_show;
          });
      },


      add:function () {
        this.$router.push({path: '/monitoring/MsgEvent_managing_add'})
      },
      issue:function () {
        if (this.program_id.length === 0){
          this.msg_show = !this.msg_show
          this.message ='请选择节目'
        }else {
          this.show = !this.show
        }
      },
      fix(id){
        this.$router.push({
          name: `MsgEvent_managing_fix`,
          params: {
            LedID:id
          }
        })
      },
      //批量删除
      BatchDelete: function () {
        if (this.program_id.length > 0) {
          this.Delete = !this.Delete
        } else {
          this.msg_show = !this.msg_show
          this.message ='请选择节目'
        }
      },
      Delete_sbt: function () {
        fetch("/api/v1/led/program/delete", {
          method: 'post',
          body: JSON.stringify({
            program_id:this.program_id
          })
        })
          .then(result => {
            return result.json();//解析流
          })
          .then(data => {
            if (data.code==="200"){
              this.msg_show = !this.msg_show;
              this.message ='删除成功';
              this.refresh = true;
            }else if(data.code==="2001"){
              this.msg_show = !this.msg_show;
              this.Delete = !this.Delete;
              this.message = "资源被占用"
            }else {
              this.msg_show = !this.msg_show;
              this.Delete = !this.Delete;
              this.message = "删除异常，请重试"
            }
          })
          .catch((error) => {
            this.msg_show = !this.msg_show;
            this.message = '网络错误，请重试';
            throw error
          });
      },


      //节目单选和全选
      ProgramCheckedOne(id) {
        let idIndex = this.program_id.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.program_id.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.program_id.push(id)
        }
      },
      ProgramCheckedAll() {
        this.ProgramIsCheckedAll = !this.ProgramIsCheckedAll
        if (this.ProgramIsCheckedAll) {
          // 全选时
          this.program_id = [];
          this.tabledata.forEach(function (tabledata) {
            this.program_id.push(tabledata.id.toString())
          }, this)
          $('input[name="program"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          this.program_id = [];
          $('input[name="program"]').each(function () {
            $(this).prop("checked", false);
          });
        }
      },


      //LED单选和全选
      LEDCheckedOne(id) {
        let idIndex = this.led_id.indexOf(id);
        if (idIndex >= 0) {
          // 如果已经包含了该id, 则去除(单选按钮由选中变为非选中状态)
          this.led_id.splice(idIndex, 1)
        } else {
          // 选中该checkbox
          this.led_id.push(id)
        }
      },
      LEDCheckedAll() {
        this.LEDIsCheckedAll = !this.LEDIsCheckedAll;
        if (this.LEDIsCheckedAll) {
          // 全选时
          this.led_id = [];
          this.issue_search_table.forEach(function (issue_search_table) {
            this.led_id.push(issue_search_table.id.toString())
          }, this)
          $('input[name="led"]').each(function () {
            $(this).prop("checked", true);
          });
        } else {
          this.led_id = [];
          $('input[name="led"]').each(function () {
            $(this).prop("checked", false);
          });
        }
      },



      issue_sbt:function () {
        console.log(this.led_id+"|"+this.program_id);
        if (this.led_id.length !== 0){
          fetch("/api/v1/led/program/release", {
            method: 'post',
            body: JSON.stringify({
              led_id:this.led_id,
              program_id:this.program_id
            })
          })
            .then(result => {
              return result.json();//解析流
            })
            .then(data => {
              console.log(data)
              if (data.code==="200"){
                this.msg_show = !this.msg_show;
                this.refresh=true;
                this.message ='发布成功'
              }else if (data.code ==="2001"){
                this.msg_show = !this.msg_show;
                this.message = "该节目已被发布，请勿重复发布"
              }else {
                this.msg_show = !this.msg_show;
                this.message = "发布异常，请重试"
              }
            })
            .catch((error) => {
              this.msg_show = !this.msg_show;
              this.message = '网络错误，请重试';
              throw error
            });
        } else {
          this.msg_show = !this.msg_show
          this.message ='请选择LED屏'
        }

      },

      leave: function () {
        if (this.refresh) {
          this.$router.push({path: '/monitoring/MsgEvent_managing'})
        }
      },
    },
    mounted() {
    },
    created() {
      this.InitLeftMenu();
      this.getProjectList();
      //获取节目列表
      fetch("/api/v1/led/program/list", {
        method: 'post',
        body: JSON.stringify({
          "project_id": "f899dfb4a9094ac48fbb27b64021d5e1",
          "page_start":"0",
          "page_size":"9",
          "is_publish": ""
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          this.tabledata = data.data;
        })
        .catch((error) => {
          console.log(error);
        });
      //获取LED屏列表
      fetch("/api/v1/led/list", {
        method: 'post',
        body: JSON.stringify({
          project_id: "17e3b71e-b460-498e-b0ef-657d20bd6549",
          // "is_publish": ""
        })
      })
        .then(result => {
          return result.json();//解析流
        })
        .then(data => {
          this.issue_search_table = data.data;
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }
</script>

<style scoped>
  .mark{
    position: absolute;
    width: calc(100% - 6px);
    height: calc(100% - 6px);
    display: flex;
    align-items: center;
    justify-content: center;
    background:transparent;
    z-index: 99999;
    left: 0;
    top: 0;
  }
  .mark_close{
    position: absolute;
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6);
    left: 0;
    top: 0;
  }
  .fade-enter-active, .fade-leave-active {
    transition: opacity .5s;
  }
  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  .search {
    width: 100%;
    height: 100px;
    padding: 20px 0px 0px;
  }

  .search_box {
    width: 100%;
    height: 100%;
    margin-right: 10px;
    background: #16518d;
    border-radius: 6px;
    float: left;
    display: flex;
    align-items: center;
    padding: 0 10px;
    box-sizing: border-box;
    position: relative;
  }

  .search_options_box {
    width: 16%;
    padding: 0 10px;
    height: 100%;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
  }

  .search_options_box > span {
    width: 64px;
    margin-right: 8px;
    text-align: right;
    color: #FFFFFF;
  }

  .search_options_box > select {
    width: calc(100% - 72px);
    height: 36px;
    border-radius: 6px;
    background: transparent;
    border: 1px solid #ffffff;
    color: #ffffff;
    appearance: none;
    padding-left: 10px;
    font-size: 16px;
    outline: none;
    cursor: pointer;
  }

  .search_options_box option {
    color: #000000;
  }

  .search_options_box > img {
    position: absolute;
    top: 48px;
    right: 20px;
    cursor: pointer;
  }

  .search_btn_box {
    width: 80px;
    padding: 10px;
  }

  .clearborder {
    outline: none;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .search_btn {
    width: 100%;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
  }

  .add_btn {
    width: 110px;
    height: 32px;
    border-radius: 6px;
    line-height: 32px;
    float: right;
    margin-right: 20px;
  }

  .icon_btn span {
    margin-right: 8px;
  }

  .green {
    background: #21b868;
    color: #FFFFFF;
  }

  .green:active {
    background: #15a95a;
  }

  .add_btn_box {
    /*width: 370px;*/
    padding: 10px;
    position: absolute;
    right: 0px;
  }

  .add {
    background: #7aafeb;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #3574ba;
  }

  .add:active {
    background: #6ca3e2;
  }
  .publish {
    background: #21b868;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #188d4f;
  }

  .publish:active {
    background: #188d4f;
  }
  .delete {
    background: #f2ae4d;
    color: #FFFFFF;
    box-shadow: 0px 3px 0px #dc8509;
  }

  .delete:active {
    background: #e7a342;
  }
  .warning {
    background: #f24d4d;
    color: #FFFFFF;
    box-shadow: 0 3px 0 #bb2323;
  }

  .warning:active {
    background: #bb2323;
  }
  .table_content{
    width: 100%;
    height: calc(100% - 100px);
    padding: 20px 0px;
  }

  .table_content > table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    background-color: #16518d;
  }

  .table_content > table tr th{
    background-color: #0e345b;
  }
  .table_content > table tr td{
    /*background-color: #16518d;*/
  }

  .table_content > table input{
    width: 16px;
    height: 16px;
  }

  .table_content > table tr:nth-child(2n){
    background-color: #11406f;
  }

  .table_content > table tr {
    /*border-bottom: 1px solid #225892;*/
    height: 62px
  }

  .table_content > table tr td, .table_content > table tr th {
    text-align: center;
    color: #FFFFFF;
  }
  .table_content > table tr th select{
    background: transparent;
    color: #FFFFFF;
    border: none;
    outline: none;

  }
  .table_content > table tr th select option{
    color: #333333;

  }
  .table_paging {
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    border: 1px solid #105ba8;
    border-radius: 6px;
  }

  .table_paging > p {
    width: 100%;
    height: 30px;
    line-height: 30px;
    text-align: right;
    margin-bottom: 0;
    color: #c1c2c6;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    padding-right: 10px;
  }

  .table_paging > p > button {
    margin: 0 8px;
    width: 10px;
    height: 16px;
    border: none;
    outline: none;
  }

  .table_btn{
    color: #95bee5;
    background: transparent;
    border: 1px solid #95bee5;
    outline: transparent;
    padding: 5px 20px;
    border-radius: 6px;
  }


  .issue_search_box{
    padding: 20px;
    box-sizing: border-box;
  }
  .issue_search_box > h1 {
    font-size: 20px;
    color: #00f0ff;
    height: 40px;
    line-height: 40px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #264a7c;
    margin-bottom: 10px;
  }
  .issue_search_box > h1>div{
    float: right;
    width: auto;
    height: 100%;
    display: flex;
    align-items: center;
  }
  .issue_search_box > h1>div>label{
    font-size: 16px;
    line-height: 40px;
    color: #FFFFFF;
    margin-bottom: 0;
  }
  .issue_search_box > h1>div>label>select, .issue_search_box > h1>div>label>input{
    border: 1px solid #FFFFFF;
    border-radius: 4px;
    background: transparent;
    height: 32px;
    line-height: 32px;
    margin:0 5px;
    width: 120px;
    color: #FFFFFF;
    outline: none;
  }
  .issue_search_box > h1>div>label>select>option{
    color: #000000;
  }
  .issue_search_box > div {
    width: 100%;
    height: 440px;
    border-radius: 8px;
    overflow: hidden;
  }

  .issue_search_box table {
    width: 100%;
    height: 100%;
    border: 1px solid #094b8e;
    border-radius: 5px;
  }

  .issue_search_box table thead tr {
    height: 50px;
    border-bottom: 1px solid #094b8e;
  }

  .issue_search_box table thead tr th {
    color: #FFFFFF;
    font-size: 16px;
  }

  .issue_search_box table tbody {
    display: block;
    height: 100%;
    overflow-y: scroll;
  }

  .issue_search_box table thead tr,
  .issue_search_box table tbody tr {
    display: table;
    width: 100%;
    table-layout: fixed;
    text-align: center;
  }

  .issue_search_box table tbody tr {
    background: #16518d;
    border-bottom: 1px solid #094b8e;
  }

  .issue_search_box table tbody tr:nth-child(2n+0) {
    background: #11406f;
  }

  .issue_search_box table tbody tr td {
    height: 40px;
    color: #FFFFFF;
  }

  .issue_search_box table tbody tr td span {
    width: 46px;
    height: 24px;
    border-radius: 3px;
    line-height: 24px;
    text-align: center;
    display: inline-block;
    font-size: 14px;
  }

  .issue_search_box thead th,
  .issue_search_box tbody td {
    width: 50px;
  }

  .issue_search_box table thead {
    width: calc(100% - 1em);
  }
</style>



// WEBPACK FOOTER //
// src/components/03Monitoring/5_msg/event_managing.vue